var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filters-wrapper" }, [
    _c(
      "ul",
      { staticClass: "filters-active" },
      [
        _vm._l(_vm.filtersActive, function(filterGroup, filterIndex) {
          return [
            filterGroup.length > 1
              ? _c(
                  "li",
                  { key: "$multi-" + filterIndex, staticClass: "list-element" },
                  [
                    _c(
                      "button",
                      {
                        ref: "button-" + filterIndex,
                        refInFor: true,
                        staticClass: "filters-active__button btn btn--small",
                        class: { "lower-index": !_vm.listOpen[filterIndex] },
                        on: {
                          click: function($event) {
                            return _vm.toggleList(filterIndex)
                          }
                        }
                      },
                      [
                        _c("span", {
                          staticClass: "filters-active__label",
                          domProps: {
                            textContent: _vm._s(
                              filterGroup[0].filterName +
                                " (" +
                                filterGroup.length +
                                ")"
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "filters-active__arrow" },
                          [
                            _c("SortIcon", {
                              class: {
                                "icon--rotate-180": _vm.listOpen[filterIndex]
                              },
                              attrs: { width: "14", height: "9" }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.listOpen[filterIndex]
                      ? _c(
                          "div",
                          {
                            ref: "list-" + filterIndex,
                            refInFor: true,
                            staticClass: "filters-active__list",
                            class: { "is-visible": _vm.listOpen[filterIndex] },
                            attrs: { tabindex: "0", role: "listbox" },
                            on: {
                              keydown: function(event) {
                                return _vm.onKeyDown(event, filterIndex)
                              }
                            }
                          },
                          _vm._l(filterGroup, function(filter, index) {
                            return _c(
                              "button",
                              {
                                key: filterIndex + "-" + index,
                                staticClass:
                                  "filters-active__list-item btn--clear",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.removeFilter({
                                      key: filterIndex,
                                      values: [filter.value]
                                    })
                                  }
                                }
                              },
                              [
                                _c("CheckboxIcon", {
                                  staticClass: "checkbox-close-icon"
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "filter-list-label",
                                  domProps: {
                                    textContent: _vm._s(
                                      filter.label || filter.filter_name
                                    )
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]
                )
              : _c("li", { key: "$single-" + filterIndex }, [
                  _c(
                    "button",
                    {
                      staticClass: "filters-active__button btn btn--small",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.handleRemoveFilter(
                            filterIndex,
                            filterGroup[0].value
                          )
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            filterGroup[0].label || filterGroup[0].filter_name
                          ) +
                          "\n                    "
                      ),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Usuń filtr")
                      ]),
                      _vm._v(" "),
                      _c("CloseIcon", {
                        attrs: { width: "20", "aria-hidden": "true" }
                      })
                    ],
                    1
                  )
                ])
          ]
        }),
        _vm._v(" "),
        _vm.hasActiveFilters && !_vm.isMobile
          ? _c("li", { staticClass: "list-clear" }, [
              _c(
                "button",
                {
                  staticClass:
                    "filters-active__button filters-active__clear btn btn--small",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.cleanFilters.apply(null, arguments)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.i18n("Clear filters")) +
                      "\n                "
                  ),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v("Usuń filtr")
                  ]),
                  _vm._v(" "),
                  _c("CloseIcon", {
                    attrs: { width: "20", "aria-hidden": "true" }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _vm.hasActiveFilters && _vm.isMobile
      ? _c("li", { staticClass: "list-clear" }, [
          _c(
            "button",
            {
              staticClass:
                "filters-active__button filters-active__clear btn btn--small",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.cleanFilters.apply(null, arguments)
                }
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.i18n("Clear filters")) +
                  "\n            "
              ),
              _c("CloseIcon", { attrs: { width: "20" } })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }